/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_DescriptionInputs */

const en_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traveling? On public Wi-Fi? Need to get around location restrictions? It's time to get your content on your terms, with the whole-device protection of Brave VPN.`)
};

const id_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang bepergian? Di Wi-Fi publik? Butuh mengatasi pembatasan lokasi? Saatnya untuk mendapatkan konten sesuai keinginan Anda, dengan perlindungan seluruh perangkat dari Brave VPN.`)
};

const ms_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang bercuti? Menggunakan Wi-Fi awam? Perlu mengatasi sekatan lokasi? Sudah tiba masanya untuk mendapatkan kandungan anda mengikut syarat anda, dengan perlindungan seluruh peranti Brave VPN.`)
};

const ca_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viatjant? Utilitzant Wi-Fi públic? Necessites esquivar restriccions de localització? És hora de veure el teu contingut segons les teves condicions, amb la protecció total del dispositiu de Brave VPN.`)
};

const cs_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestujete? Jste na veřejné Wi-Fi? Potřebujete obejít omezení podle polohy? Je čas získat obsah podle vašich podmínek, s ochranou celého zařízení od Brave VPN.`)
};

const da_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På farten? På offentlig Wi-Fi? Har du brug for at omgå lokalitetsbegrænsninger? Det er tid til at få dit indhold på dine vilkår med beskyttelse af hele din enheden med Brave VPN.`)
};

const de_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reisen Sie? Auf öffentlichem WLAN? Müssen Sie Standort-Einschränkungen umgehen? Es ist an der Zeit, Ihre Inhalte nach Ihren Wünschen zu erhalten, mit dem Geräteschutz von Brave VPN.`)
};

const et_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas reisite? Kasutage avalikku Wi-Fi võrku? Vaja on vältida asukohapiiranguid? On aeg saada oma sisu oma tingimustel, koos täieliku seadmekaitsega Brave VPN abil.`)
};

const es_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Viajando? ¿En Wi-Fi público? ¿Necesitas sortear restricciones de ubicación? Es hora de obtener tu contenido en tus términos, con la protección de todo tu dispositivo con Brave VPN.`)
};

const fr_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous voyagez ou utilisez un Wi-Fi public ? Besoin de contourner les restrictions géographiques ? Accédez à tous vos contenus en toute liberté, tout en protégeant l’ensemble de votre appareil grâce au VPN Brave.`)
};

const hr_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putujete? Na javnom Wi-Fi-ju? Trebate zaobići ograničenja lokacije? Vrijeme je da dobijete svoj sadržaj pod svojim uvjetima, uz zaštitu cijelog uređaja koja dolazi s Brave VPN-om.`)
};

const it_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In viaggio? Su Wi-Fi pubblico? Hai bisogno di aggirare le restrizioni di localizzazione? È ora di accedere ai contenuti che vuoi e nel modo che vuoi con la protezione completa di Brave VPN.`)
};

const lv_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceļojat? Izmantojat publisko Wi-Fi? Vēlaties apiet atrašanās vietas ierobežojumus? Ir laiks piekļūt jūsu saturam uz jūsu noteikumiem ar Brave VPN pilnīgu ierīces aizsardzību.`)
};

const lt_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keliauji? Naudojiesi viešuoju Wi-Fi? Reikia apeiti vietos apribojimus? Laikas valdyti savo turinį pagal savo sąlygas, su Brave VPN viso įrenginio apsauga.`)
};

const hu_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utazik? Nyilvános Wi-Fi-n van? Helymeghatározási korlátozásokkal kell szembenéznie? Itt az idő, hogy az igényeinek megfelelően használja a tartalmát, a Brave VPN teljes eszközvédelmével.`)
};

const nl_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op reis? Op publieke Wi-Fi? Moet je locatiebeperkingen omzeilen? Het is tijd om je content op jouw voorwaarden te krijgen, met de bescherming van het gehele apparaat van Brave VPN.`)
};

const nb_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ute på reise? Koblet til et offentlig Wi-Fi? Trenger du å omgå stedsrestriksjoner? Det er på tide å se innholdet ditt på dine vilkår, og beskytte hele enheten med Brave VPN.`)
};

const pl_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podróżujesz? Używasz publicznego Wi-Fi? Chcesz ominąć ograniczenia lokalizacyjne? Zyskaj dostęp do treści na własnych warunkach – z ochroną całego urządzenia dzięki Brave VPN.`)
};

const pt_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viajando? Em um Wi-Fi público? Precisa contornar restrições de localização? É hora de obter seu conteúdo sob seus próprios termos, com a proteção de todo o dispositivo do Brave VPN.`)
};

const ro_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Călătoriți? Sunteți în Wi-Fi public? Aveți nevoie să ocoliți restricțiile de locație? E timpul să obțineți conținutul dvs. în condițiile dvs., cu protecția pe tot dispozitivul oferită de Brave VPN.`)
};

const sk_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestujete? Na verejnej Wi-Fi? Potrebujete obísť obmedzenia miesta? Je čas dostať sa k svojmu obsahu podľa vašich predstáv s ochranou celého zariadenia pomocou Brave VPN.`)
};

const sl_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potujete? Na javnem Wi-Fi-ju? Potrebujete obhod omejitev lokacije? Čas je, da dobite vsebino po svojih pogojih, z zaščito celotne naprave Brave VPN.`)
};

const fi_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matkustatko? Julkisessa Wi-Fissä? Tarvitsetko kiertämistä sijaintirajoituksista? On aika saada sisältösi omilla ehdoillasi, Brave VPN:n koko laitteen suojalla.`)
};

const sv_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reser du? På offentlig Wi-Fi? Behöver du komma runt platsbegränsningar? Det är dags att få ditt innehåll på dina villkor, med hela enhetsskyddet från Brave VPN.`)
};

const vi_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang du lịch? Trên Wi-Fi công cộng? Cần vượt qua các hạn chế về vị trí? Đã đến lúc trải nghiệm nội dung của bạn theo cách mong muốn, với sự bảo vệ toàn diện của Brave VPN.`)
};

const tr_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seyahat mi ediyorsunuz? Herkese açık Wi-Fi mi kullanıyorsunuz? Konum kısıtlamalarını atlatmanız mı gerekiyor? Şimdi Brave VPN'nin tüm cihaz koruması ile içeriklere kendi koşullarınızla ulaşma vakti.`)
};

const el_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ταξιδεύετε; Σε δημόσιο Wi-Fi; Χρειάζεται να παρακάμψετε τους περιορισμούς τοποθεσίας; Είναι καιρός να αποκτήσετε το περιεχόμενό σας σύμφωνα με τους δικούς σας όρους, με την ολοκληρωμένη προστασία συσκευής του Brave VPN.`)
};

const bg_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пътувате ли? На публична Wi-Fi мрежа ли сте? Трябва ли да заобиколите ограниченията по местоположение? Време е да получите съдържанието си според вашите условия, с цялостната защита на устройството от Brave VPN.`)
};

const ru_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путешествуете? Находитесь в общественном Wi-Fi? Нужно обойти геолокационные ограничения? Пора получить доступ к вашему контенту на ваших условиях с полной защитой устройства от Brave VPN.`)
};

const sr_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путујете? На јавном Wi-Fi-у? Требате заобићи локацијска ограничења? Време је да добијете садржај по вашим условима уз заштиту свих уређаја помоћу Brave VPN.`)
};

const uk_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подорожуєте? На публічному Wi-Fi? Потрібно обійти обмеження за місцезнаходженням? Час отримати ваш контент за вашими умовами із захистом всього пристрою від Brave VPN.`)
};

const ka_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მოგზაურობა? საზოგადოებრივ Wi-Fi-ზე? გჭირდებათ ლოკაციური შეზღუდვების ჭრა? დროა მიიღოთ თქვენი კონტენტი თქვენი პირობებით, ყველა-მოწყობილობის დაცვით Brave VPN-ის გამოყენებით.`)
};

const hi_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यात्रा कर रहे हैं? सार्वजनिक वाई-फाई पर हैं? स्थान प्रतिबंधों को बायपास करने की आवश्यकता है? अपने सामग्री को अपनी शर्तों पर प्राप्त करने का समय है, पूरे-डिवाइस सुरक्षा के साथ Brave VPN।`)
};

const th_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเดินทาง? เชื่อมต่อกับ Wi-Fi สาธารณะ? ต้องการเลี่ยงข้อจำกัดทางสถานที่? ถึงเวลาเลือกเนื้อหาของคุณบนเงื่อนไขของคุณเอง ด้วยการป้องกันทั้งอุปกรณ์จาก Brave VPN`)
};

const ko_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여행 중이거나 공용 Wi-Fi를 사용 중이거나, 위치 제한을 우회하고 싶으신가요? 기기에 전체적인 보호를 제공하는 Brave VPN을 통해 내가 원하는 방식대로 콘텐츠를 이용해 보세요.`)
};

const zh_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在旅行？在使用公共 Wi-Fi？需要绕过位置限制？您可以通过 Brave VPN 的全设备保护轻松获取所需内容。`)
};

const zh_tw_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前正在旅行？使用公共 Wi-Fi？需要突破地域限制？是時候透過 Brave VPN 的全裝置防護，按您的方式暢享內容了。`)
};

const ja_vpn_description = /** @type {(inputs: Vpn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行中ですか？公共のWi-Fiを使用していますか？位置制限を回避する必要がありますか？デバイス全体を保護するBrave VPNなら、好きなように好きな時にコンテンツにアクセスできます。`)
};

/**
* | output |
* | --- |
* | "Traveling? On public Wi-Fi? Need to get around location restrictions? It's time to get your content on your terms, with the whole-device protection of Brave ..." |
*
* @param {Vpn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_description = /** @type {((inputs?: Vpn_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_description(inputs)
	if (locale === "ms") return ms_vpn_description(inputs)
	if (locale === "ca") return ca_vpn_description(inputs)
	if (locale === "cs") return cs_vpn_description(inputs)
	if (locale === "da") return da_vpn_description(inputs)
	if (locale === "de") return de_vpn_description(inputs)
	if (locale === "et") return et_vpn_description(inputs)
	if (locale === "es") return es_vpn_description(inputs)
	if (locale === "fr") return fr_vpn_description(inputs)
	if (locale === "hr") return hr_vpn_description(inputs)
	if (locale === "it") return it_vpn_description(inputs)
	if (locale === "lv") return lv_vpn_description(inputs)
	if (locale === "lt") return lt_vpn_description(inputs)
	if (locale === "hu") return hu_vpn_description(inputs)
	if (locale === "nl") return nl_vpn_description(inputs)
	if (locale === "nb") return nb_vpn_description(inputs)
	if (locale === "pl") return pl_vpn_description(inputs)
	if (locale === "pt") return pt_vpn_description(inputs)
	if (locale === "ro") return ro_vpn_description(inputs)
	if (locale === "sk") return sk_vpn_description(inputs)
	if (locale === "sl") return sl_vpn_description(inputs)
	if (locale === "fi") return fi_vpn_description(inputs)
	if (locale === "sv") return sv_vpn_description(inputs)
	if (locale === "vi") return vi_vpn_description(inputs)
	if (locale === "tr") return tr_vpn_description(inputs)
	if (locale === "el") return el_vpn_description(inputs)
	if (locale === "bg") return bg_vpn_description(inputs)
	if (locale === "ru") return ru_vpn_description(inputs)
	if (locale === "sr") return sr_vpn_description(inputs)
	if (locale === "uk") return uk_vpn_description(inputs)
	if (locale === "ka") return ka_vpn_description(inputs)
	if (locale === "hi") return hi_vpn_description(inputs)
	if (locale === "th") return th_vpn_description(inputs)
	if (locale === "ko") return ko_vpn_description(inputs)
	if (locale === "zh") return zh_vpn_description(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_description(inputs)
	if (locale === "ja") return ja_vpn_description(inputs)
	return en_vpn_description(inputs)
});